<template>
    <div class="common_container">
        <el-form :model="form" :rules="rules" ref="form" label-width="80px">

            <!-- 请填写IP 主机名 -->
            <el-row>
                <el-col :span="24" >
                    <el-form-item label="IP" prop="ip">
                        <el-input v-model="form.ip" placeholder="请填写IP" class="form-input"/>
                    </el-form-item>
                </el-col>

                <el-col :span="24" >
                    <el-form-item label="salt-id" prop="hostname">
                        <el-input v-model="form.hostname" placeholder="请填写主机名" class="form-input"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 环境 所属组 -->
            <!--<el-row>-->
                <!--<el-col :span="24" >-->
                    <!--<el-form-item label="环境" prop="env">-->
                        <!--<el-select v-model="form.env" placeholder="请选择环境" style="display:block" clearable>-->
                            <!--<el-option v-for="item in envList" :key="item.default" :label="item.cname" :value="item.default"/>-->
                        <!--</el-select>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->

            <!-- 状态 -->
            <el-row>
                <!--<el-col :span="24" >-->
                    <!--<el-form-item label="有其他IP">-->
                        <!--<el-switch v-model="form.if_other_ip" active-text="是" inactive-text="否" active-value="1" inactive-value="0"/>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->

                <el-col :span="12" >
                    <el-form-item label="状态">
                        <el-select v-model="form.status" placeholder="请选择状态" class="form-input" clearable>
                            <el-option v-for="item in status_list" :key="item.value" :label="item.label" :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--&lt;!&ndash; 有其他IP &ndash;&gt;-->
            <!--<el-row>-->
                <!--<el-col :span="24">-->
                    <!--<el-form-item v-if="form.if_other_ip == '1'" label="其他IP">-->
                        <!--<el-input v-model="form.other_ip_data" :autosize="{ minRows: 6, maxRows: 6}" type="textarea" placeholder="例:127.0.0.1/localhost,若有多个ip请分别换行输入"/>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="其他IP">
                        <otherIp :getData="getOtherIpData" :data="form.other_ip" :type="type" class="form-input"></otherIp>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit('form')" :disabled="isSubmit">确定</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import otherIp from './otherIp'
    import services from "./server.services";
    import { getRules } from "./server.rules";
    const rules = getRules();

    export default {
        components:{
            otherIp
        },
        props:{
            type: {
                type:String,
                default:"add"
            },
            serverId:Number,
            callback: Function
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2;
            },
            envList() {
                return this.dictionary.env;
            }
        },

        data() {
            return {
                status_list: [],
                group_server: [],
                form: {
                    ip: "",
                    hostname: "",
                    env: "",
                    status: 0,
                    group_name: "",
                    if_other_ip: "0",
                    other_ip_data: "",
                    other_ip: []
                },
                isSubmit:false,
                rules
            }
        },

        created() {

            this.loading = false;
        },

        mounted() {
            if(this.type == "edit"){
                this.$modal.title = "编辑服务器";
                // console.log(this.$route);
                // console.log(this.$route.query.serverId,'serverId');
                this.getDetail()
            }
            this.status_list = [{ value: 0, label: "默认状态" }];
        },

        methods: {
            // 获取详情
            getDetail() {
                // console.log(this.serverId,'serverId');
                services.serverInfo({ id: this.serverId })
                    .then(res => {
                        // console.log(res);
                        this.form = { ...this.form, ...res, status: +res.status || 0 }
                        // console.log(this.form);
                    })
            },
            getOtherIpData(val){
                this.form.other_ip=val
                // this.form.other_ip=this.form.other_ip.concat(val)
                // console.log(this.form.other_ip,'this.form.other_ip');
            },
            // 点击取消
            onCancel() {
                this.$modal.close();
            },

            // 获取atams
            getparams() {
                return {
                    id:this.form.id,
                    ip: this.form.ip,
                    hostname: this.form.hostname,
                    other_ip_list: this.form.other_ip,
                    owner: this.server_id,
                    // env: this.form.env,
                    status: this.form.status,
                    group_name: "",    //固定传空，后期可能不用这个功能
                };
            },

            // 点击确定
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.isSubmit=true
                        const loading = this.$loading({
                            lock: true,
                            text: "Loading",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)"
                        })
                        // console.log(this.form.other_ip_data);
                        if (this.type === "add") this.sendRequest(loading, services.addServer, "添加成功");
                        else if (this.type === "edit") this.sendRequest(loading, services.updateServer, "编辑成功");
                    } else {
                        this.isSubmit=false
                        return false;
                    }
                })
            },

            // 发送请求
            sendRequest(loading, requestFn, title) {
                const params = this.getparams();
                // console.log(params);
                requestFn(params)
                    .then(response => {
                        this.isSubmit=true
                        this.$message.success(title)
                    }).catch( err => {
                        this.isSubmit=false
                        this.$message.error(err.message)})
                    .finally(() => {
                        loading.close();
                        this.$modal.close();
                        this.callback();
                    })

            },

            // 添加请求
            // AddServer(loading) {
            //     const params = this.getparams();
            //     services.addServer(params)
            //         .then(response => this.$message.success("添加成功"))
            //         .catch( err => this.$message.error(err.message))
            //         .finally(() => {
            //             loading.close();
            //             this.$modal.close();
            //             this.callback();
            //         })
            // },

            // 编辑请求
            // UpdataServer(loading) {
            //     const params = this.getparams();
            //     services.updateServer(params)
            //         .then(response => this.$message.success("编辑成功"))
            //         .catch( err => this.$message.error(err.message))
            //         .finally(() => {
            //             loading.close();
            //             this.$modal.close();
            //             this.callback();
            //         })
            // }
        }
    }
</script>
<style lang="scss" scoped rel="stylesheet/scss">

</style>
